/**
 * transforms and formats people group error
 * @param  {Object} error
 * @return {string[]}
 */
export const transformPeopleGroupError = (error) => {
  return error?.promptErrors || (error?.detail ? [error.detail] : undefined) || error || [];
};
